import { LocalReports as Component } from './components';
import Connector from './connector';
import { ConnectorProps } from './LocalReports.proptype';

export interface LocalReportsProps extends Omit<ConnectorProps, 'component'> {}

export const LocalReports = (props: LocalReportsProps) => <Connector {...props} component={Component} />;
